export default __webpack_public_path__ + "static/media/fs-community.ac50a59c.svg";